/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Cancel_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Cancel in-progress sync?" |
*
* @param {Snapshot_History_Cancel_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_cancel_confirm_title = /** @type {((inputs?: Snapshot_History_Cancel_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Cancel_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cancel in-progress sync?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cancel in-progress sync?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancel in-progress sync?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Cancel in-progress sync?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancel in-progress sync?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Cancel in-progress sync?")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Cancel in-progress sync?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Cancel in-progress sync?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancel in-progress sync?")
	return /** @type {LocalizedString} */ ("Cancel in-progress sync?")
});